import styled from 'styled-components';

const ItemCount = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary || '#555'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    font-size: ${({ theme }) => theme.fontSizes.small || '0.85rem'};
  }
`;

export default ItemCount;
